jQuery(document).ready(function ($) {

    let $meta_box_questionnarie = $('#meta-box-questionnarie');
    
    $meta_box_questionnarie.find('.widget-top').click(function(){
        $(this).parent().toggleClass('open');
        $(this).next().slideToggle();
    });

    $('.reset-step-js').click(function (event) {
        let user_id = $(this).data('user-id');
        let position = $(this).prev().val();

        request_reset('reset_current_step', user_id, position).then((response) => {
            $('.count-reset-step-js').text(response);
            $('.status-name-js').text('');
        });
    });

    $('.reset-pending-js').click(function (event) {
        var user_id = $(this).data('user-id');

        $.post(ajaxurl, // ajaxurl funciona dentro do backoffice
            {
                'action': 'reset_pending',
                'user_id': user_id
            }, function (response) {
                $('.status-name-js').text('Pending');
                return response;
            });
    });

    $('.reset-stage-js').click(function (event) {
        let user_id = $(this).data('user-id');
        let position = $(this).prev().val();

        request_reset('reset_current_stage', user_id, position).then((response) => {
            $('.count-reset-stage-js').text(response);
        });
    });

    
    $('.btn-meta-box-send-js').click(function (event) {
        let $next_step = $('.input-next-step-js');
        let is_checked = $next_step.is(":checked");
        let next_step = $next_step.val();
        let post_id = $(this).data('postid');
        let user_id = $(this).data('userid');

        if (is_checked) {
            meta_box_authorize_next_step(user_id, next_step).then((response) => {
                $('.user-notices').html('Autorizado com sucesso!!');
            });
        }

        let mensage_email = $('.mensage-send-email-js');
        mensage_email = mensage_email[0].value;

        meta_box_send_email(user_id, mensage_email).then((response) => {

            $('.user-notices').html('Enviado com sucesso!!');

            setTimeout(() => {
                location.reload();
            }, 1000);
        });
    });


    function request_reset(function_name, user_id, position = 1) {

        return $.post(
            ajaxurl, // ajaxurl funciona dentro do backoffice
            {
                'action': function_name,
                'user_id': user_id,
                'position': position
            },
            function (response) {
                return response;
            }
        );
    }

    function meta_box_authorize_next_step(user_id, next_step) {

        return $.post(
            ajaxurl, // ajaxurl funciona dentro do backoffice
            {
                'action': 'user_authorize_next_step',
                'next_step': next_step,
                'user_id': user_id
            },
            function (response) {
                console.log(response);
                return response;
            }
        );
    }

    function meta_box_send_email(user_id, mensage) {

        return $.post(
            ajaxurl, // ajaxurl funciona dentro do backoffice
            {
                'action': 'user_send_email',
                'mensage': mensage,
                'user_id': user_id
            },
            function (response) {
                console.log(response);
                return response;
            }
        );
    }

});


// WEBPACK FOOTER //
// ./src/js/admin-questionnarie.js